<template>
  <div class="col-12">
    <div class="st-meta float-right">
      <div class="element-actions">
        <div class="btn-group">
          <button
            aria-expanded="false"
            aria-haspopup="true"
            class="btn btn-secondary btn-md dropdown-toggle"
            data-toggle="dropdown"
            type="button"
          >
            <i class="fa fa-cogs"></i>
            Acciones
          </button>
          <div class="dropdown-menu dropdown-menu-right">
            <button
              class="dropdown-item"
              data-target="#modalFinalizarCarga"
              data-toggle="modal"
              href="#"
            >
              <i class="fas fa-truck"></i>
              Finalizar Carga
            </button>
            <button
              class="dropdown-item"
              data-target="#modalFinalizarEnvio"
              data-toggle="modal"
              href="#"
            >
              <i class="fas fa-shipping-fast"></i>
              Enviar a ruta
            </button>
            <button
              class="dropdown-item"
              data-target="#modalRetorno"
              data-toggle="modal"
              href="#"
            >
              <i class="fas fa-route"></i>
              Finalizar contendor
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="modalFinalizarCarga"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content text-center">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span class="close-label">Cancelar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding">
            <div class="onboarding-content with-gradient">
              <div class="text-center">
                <h5 class="onboarding-title text-center">
                  Finalizar Carga de Contenedor
                </h5>
              </div>
              <form @submit="finalizarCarga">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="input-group">
                      <input
                        v-model="current.barra"
                        class="form-control"
                        placeholder="Barra #"
                        type="text"
                        ref="barraFinalizarY"
                      />
                      <small
                        v-if="current.errors && current.errors.barra"
                        class="form-text text-danger"
                        >{{ current.errors.barra[0] }}</small
                      >
                    </div>
                  </div>
                </div>
                <br />
                <button class="btn btn-primary btn-block" type="submit">
                  <i class="fas fa-plus"></i> Agregar
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="modalFinalizarEnvio"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content text-center">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span class="close-label">Cancelar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding">
            <div class="onboarding-content with-gradient">
              <div class="text-center">
                <h5 class="onboarding-title text-center">Enviar Contenedor</h5>
              </div>
              <form @submit="finalizarEnvio">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="input-group">
                      <input
                        v-model="current.barra"
                        class="form-control"
                        placeholder="Barra #"
                        type="text"
                        ref="barraEnviarx"
                      />
                      <small
                        v-if="current.errors && current.errors.barra"
                        class="form-text text-danger"
                        >{{ current.errors.barra[0] }}</small
                      >
                    </div>
                  </div>
                </div>
                <br />
                <button class="btn btn-primary btn-block" type="submit">
                  <i class="fas fa-plus"></i> Agregar
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="modalRetorno"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content text-center">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span class="close-label">Cancelar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding">
            <div class="onboarding-content with-gradient">
              <div class="text-center">
                <h5 class="onboarding-title text-center">
                  Finalizar Retorno de Contenedor
                </h5>
              </div>
              <form @submit="finalizarRetorno">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="input-group">
                      <input
                        v-model="current.barra"
                        class="form-control"
                        placeholder="Barra #"
                        type="text"
                        ref="barraFinalizarx"
                      />
                      <small
                        v-if="current.errors && current.errors.barra"
                        class="form-text text-danger"
                        >{{ current.errors.barra[0] }}</small
                      >
                    </div>
                  </div>
                </div>
                <br />
                <button class="btn btn-primary btn-block" type="submit">
                  Agregar
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import CommonService from "@/services/commons/CommonService";
import Notifications from "@/notifications/notifications";
import { mapGetters } from "vuex";
import ContenedorService from "@/services/wms/ContenedorService";

export default {
  props: {},
  components: {},
  data() {
    return {
      current: [],
      cajas: [],
      cliente: {
        nit: null,
        email: "",
      },
      encargado: [],
    };
  },
  watch: {},
  computed: {},
  mounted() {
    let self = this;
    $(".modal").on("shown.bs.modal", function () {
      self.$refs.barraFinalizarY.focus();
    });
    $(".modal").on("shown.bs.modal", function () {
      self.$refs.barraFinalizarx.focus();
    });
    $(".modal").on("shown.bs.modal", function () {
      self.$refs.barraEnviarx.focus();
    });
  },
  methods: {
    cerrandoModal() {
      this.$emit("cerrandomodal");
    },

    finalizarCarga(e) {
      let self = this;
      e.preventDefault();
      var det = Object.assign({}, this.current);
      console.log(det.barra);
      ContenedorService.finalizar_carga({ barra: det.barra })
        .then((res) => {
          self.current.errors = {};
          Notifications.toast.success(
            "Finalizar Carga",
            "Realizado correctamente"
          );
          self.$emit("refresh", {});
          $("#modalFinalizarCarga").modal("hide");
          self.cerrandoModal();
        })
        .catch((error) => {
          Vue.nextTick(function () {
            self.current.errors = Object.assign({}, error.response.data);
            if ("detail" in error.response.data) {
              Notifications.alert.error("Error", error.response.data.detail);
            }
          });
        });
    },
    finalizarEnvio(e) {
      let self = this;
      e.preventDefault();
      var det = Object.assign({}, this.current);
      console.log(det.barra);
      ContenedorService.finalizar_envio({ barra: det.barra })
        .then((res) => {
          self.current.errors = {};
          Notifications.toast.success(
            "Finalizar envío",
            "Realizado correctamente"
          );
          self.current.barra = "";
          self.$emit("refresh", {});
          $("#modalFinalizarEnvio").modal("hide");
          self.cerrandoModal();
        })
        .catch((error) => {
          Vue.nextTick(function () {
            self.current.errors = Object.assign({}, error.response.data);
            if ("detail" in error.response.data) {
              Notifications.alert.error("Error", error.response.data.detail);
            }
          });
        });
    },
    finalizarRetorno(e) {
      let self = this;
      e.preventDefault();
      var det = Object.assign({}, this.current);
      console.log(det.barra);
      ContenedorService.retorno({ barra: det.barra })
        .then((res) => {
          self.current.errors = {};
          Notifications.toast.success(
            "Finalizar Retorno",
            "Realizado correctamente"
          );
          self.$emit("refresh", {});
          $("#modalRetorno").modal("hide");
          self.cerrandoModal();
        })
        .catch((error) => {
          Vue.nextTick(function () {
            self.current.errors = Object.assign({}, error.response.data);
            if ("detail" in error.response.data) {
              Notifications.alert.error("Error", error.response.data.detail);
            }
          });
        });
    },
  },
};
</script>
